import React, { useEffect, useState } from "react";
import { Autocomplete, InputAdornment, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import AutocompleteSkeleton from "../../../shared/components/skeletons/AutocompleteSkeleton";
import { capitalizeWords, finderSucursalByName } from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  hoursAvailableState,
  isChangeFormSearchState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import { sucursalesState } from "./state/atoms";

import {
  specialitiesByServiceState,
  specialitiesState,
  professionalsByServiceState,
  professionalsState,
} from "./state/atoms";
import { PlaceOutlined } from "@mui/icons-material";
import SucursalIcon from "../../../shared/icons/SucursalIcon";
import SpecialityService from "src/services/agenda/specialities";

const AutocompleteSucursales = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const [loading, setLoading] = useState(false);
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const sucursales = useRecoilValue(sucursalesState);
  const [specialities, setSpecialities] = useRecoilState(specialitiesState);
  const [professionals, setProfessionals] = useRecoilState(professionalsState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );

  const loadSpeciality = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          let sucursalCode = filterSearchSelected.sucursalSelected.code;
          let specialityValue = filterSearchSelected.specialitySelected.value;
          let clinicaValue = filterSearchSelected.clinicaSelected.value;
          console.log("code5 6", sucursalCode, specialityValue);
          
          if(sucursalCode != null && specialityValue != ""){
            console.log("SUCURSAL SPECIALIDAD ====> ", sucursalCode, specialityValue);
            const specialitiesFetch = await snapshot.getPromise(
              specialitiesByServiceState(sucursalCode)
            );
            const responses = await Promise.all([
              specialitiesFetch,
            ]);
            setSpecialities(responses[0]);
          } else if (sucursalCode != null) {
            const specialitiesFetch = await snapshot.getPromise(
              specialitiesByServiceState(sucursalCode)
            );
            let obj = {
              codSpeciality: "0",
              sucursalCode: sucursalCode,
            };
            const professionalsFetch = snapshot.getPromise(
              professionalsByServiceState(obj)
            );
            const responses = await Promise.all([
              specialitiesFetch,
              professionalsFetch,
            ]);
            console.log("SUCURSAL ====> ", sucursalCode, specialityValue);
            console.log(responses[1], "code5 4");

            setSpecialities(responses[0]);
            setProfessionals(responses[1]);
          }else if(clinicaValue != "" && specialityValue === ""){
            console.log("UBICACION ====> ", sucursalCode, specialityValue);
            const promise1 = new Promise(async (resolve, reject) => {
              try {
                const { data } = await SpecialityService.getAll();
                resolve(data.data);
              } catch (error) {
                reject(error);
              }
            });
  
            const promise2 = new Promise(async (resolve, reject) => {
              try {
                const response = await SpecialityService.getProfessionals(0);
                resolve(response.data.data);
              } catch (error) {
                reject(error);
              }
            });

            const responses = await Promise.all([promise1, promise2]);
            console.log(responses[1], "code5 4");
            
            setSpecialities(responses[0]);
            setProfessionals(responses[1]);
          }
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    [filterSearchSelected.sucursalSelected.value]
  );

  useEffect(() => {
    loadSpeciality();

    // return () => {
    //     loadSpeciality();
    // }
  }, [loadSpeciality]);

  //if (loading) return <AutocompleteSkeleton />
  
  const lugar = window.location.pathname.indexOf("buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-sucursal"
        text="Sucursal"
        style={{ ...styles.label }}
      />
      <Autocomplete
        sx={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-sucursal"
        options={
          sucursales ? sucursales.map((option) => `${option.sueNombre}`) : []
        }
        //options={sucursales.map((option) => `${option.serNombre}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.sucursalSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          resetHoursAvailable();
          resetProfessionalsMatchCovenant();
          resetProfessionalsNoMatchCovenant();

          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              sucursalSelected: {
                ...filterSearchSelected.sucursalSelected,
                value: "",
                code: null,
              },
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const findSucursal = finderSucursalByName(sucursales, value);
            setFilterSearchSelected({
              ...filterSearchSelected,
              sucursalSelected: {
                ...filterSearchSelected.sucursalSelected,
                value: value,
                code: findSucursal?.serCodigo,
              },
              specialitySelected: {
                ...filterSearchSelected.specialitySelected,
                value: "",
                code: null,
              },
              professionalSelected: {
                ...filterSearchSelected.professionalSelected,
                value: "",
                code: null,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              input: {
                "&::placeholder": {
                  ...styles.autocomplete,
                  opacity: 1,
                  fontWeight: 400,
                },
              },
            }}
            placeholder="Sucursal"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                (lugar > 0 ) ?                 
                <>
                <SvgIcon sx={{fontSize: "15px"}}>
                  <SucursalIcon />
                </SvgIcon>
                  {params.InputProps.startAdornment}
                </>: null

              ),                
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteSucursales;
